import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/auth/AuthContext";
import ProtectedRoute from "@/auth/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import LiveMapPage from "@/pages/LiveMapPage";
import AssetsPage from "@/pages/AssetsPage";
import JobsPage from "@/pages/JobsPage";
import CompliancePage from "@/pages/CompliancePage";
import HistoryPage from "@/pages/HistoryPage";
import SuperPage from "@/pages/SuperPage";
import RoutePlannerPage from "@/pages/RoutePlannerPage";
import SavedRoutesPage from "@/pages/SavedRoutesPage";
import MaintenancePage from "@/pages/MaintenancePage";
import BillingPage from "@/pages/BillingPage";
import BillingSuccessPage from "@/pages/BillingSuccessPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import LandingPage from "@/pages/LandingPage";
import PricingPage from "@/pages/PricingPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import DriverPage from "@/pages/DriverPage";
import PublicReceiptPage from "@/pages/PublicReceiptPage";
import FeedbackPage from "@/pages/FeedbackPage";
import InvoicesPage from "@/pages/InvoicesPage";
import DVIRPage from "@/pages/DVIRPage";
import ExpirationsPage from "@/pages/ExpirationsPage";
import FleetHealthPage from "@/pages/FleetHealthPage";
import InstallPrompt from "@/components/pwa/InstallPrompt";
import OfflineBanner from "@/components/pwa/OfflineBanner";
import DemoTour from "@/components/onboarding/DemoTour";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <OfflineBanner />
          <Routes>
            {/* Public marketing */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/billing/success" element={<BillingSuccessPage />} />
            <Route path="/receipt/:token" element={<PublicReceiptPage />} />

            {/* Protected app */}
            <Route element={<ProtectedRoute />}>
              <Route path="/driver" element={<DriverPage />} />
              <Route element={<DashboardLayout />}>
                <Route path="/live" element={<LiveMapPage />} />
                <Route path="/assets" element={<AssetsPage />} />
                <Route path="/jobs" element={<JobsPage />} />
                <Route path="/routes" element={<RoutePlannerPage />} />
                <Route path="/routes/saved" element={<SavedRoutesPage />} />
                <Route path="/maintenance" element={<MaintenancePage />} />
                <Route path="/compliance" element={<CompliancePage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/super" element={<SuperPage />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/invoices" element={<InvoicesPage />} />
                <Route path="/dvir" element={<DVIRPage />} />
                <Route path="/expirations" element={<ExpirationsPage />} />
                <Route path="/fleet-health" element={<FleetHealthPage />} />
                <Route path="/billing" element={<BillingPage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
          <DemoTour />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
